import {
  Checkbox,
  Editable, EditableInput, EditablePreview, Flex, HStack, Input, Text,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useDispatch } from 'react-redux';
import Preview from './Preview';
import { setFormMessages } from '../formSlice';

const Messages = ({ form }) => {
  const dispatch = useDispatch();
  const text = get(form, 'messages.string-empty.value', '{#label} is required');
  const bold = get(form, 'messages.string-empty.bold', true);
  const quotes = get(form, 'messages.string-empty.quotes.enabled', false);
  const quotesValue = get(form, 'messages.string-empty.quotes.value', '"');

  const updateMessage = ({
    t, b, q, qv,
  }) => {
    dispatch(setFormMessages({
      value: t ?? text,
      bold: b ?? bold,
      quotes: {
        enabled: q ?? quotes,
        value: qv ?? quotesValue,
      },
    }));
  };
  return (
    <Flex direction="column" minH="250px">
      <Text>
        Default validation message for required fields:
      </Text>
      <Text color="gray.400" fontSize="sm">
        You can add
        {' '}
        <b>{'{#label}'}</b>
        {' '}
        to use the label of the field on the message
      </Text>
      <Editable my="2" value={text} fontFamily="monospace" fontSize="sm" onChange={(t) => updateMessage({ t })}>
        <EditablePreview bg="gray.100" px="2" w="100%" />
        <EditableInput />
      </Editable>
      <Checkbox isChecked={bold} onChange={(e) => updateMessage({ b: e.target.checked })}>bold</Checkbox>
      <HStack>
        <Checkbox isChecked={!!quotes} onChange={(e) => updateMessage({ q: e.target.checked })}>quotes</Checkbox>
        <Input
          size="xs"
          width="25px"
          value={quotesValue}
          maxLength="1"
          isDisabled={!quotes}
          onChange={(e) => updateMessage({ qv: e.target.value })}
        />
      </HStack>

      <Preview message={text} bold={bold} quotes={quotes ? quotesValue : false} />
    </Flex>
  );
};

export default Messages;
